<script setup>
import {runCookieConsent} from "~/utils/runCookieConsent"
import {useCookies} from '@vueuse/integrations/useCookies'
import {isEmpty} from "lodash"
import {useAuthStore} from "~/store/auth"

const config = useRuntimeConfig()
const route = useRoute()
const authStore = useAuthStore()

onMounted(() => {
  const locale = 'es'
  const revision = config.public.cookiesRevision

  setTimeout(() => {
    const cookies = useCookies(['cc_cookie'])
    const firstTime = isEmpty(cookies.get('cc_cookie'))

    runCookieConsent(revision, locale, firstTime)
  }, 500)
})
</script>

<template>
</template>
